import { IRegisterUser } from '../auth';
import { Attachment, ISelect } from '../shared';
import { Account } from './account';

export enum PqrReception {
    CRM = 'CRM',
    PQR_WEB = 'PQR_WEB',
    SFC = 'SFC',
}

export enum PqrStatusSmart {
    'KEY_1' = 'Recibida',
    'KEY_2' = 'Abierta',
    'KEY_3' = 'Abierta en conciliación',
    'KEY_4' = 'Cerrada',
}

export const pqrStatusSmartList = Object.entries(PqrStatusSmart).map(
    ([id, name]) => ({ id, name })
);

export interface PqrFilter {
    caseId?: string;
    pqrId?: string;
    sfcId?: string;
    document?: string;
    name?: string;
    receptionChannel?: string[] | ISelect;
    half?: string[] | ISelect;
    type?: string[] | ISelect;
    branch?: string[] | ISelect;
    incharge?: string[] | ISelect;
    reconsideration?: string[] | ISelect;
    survey?: boolean;
    correspondenceFiling?: string;
    status?: string[] | ISelect;
    reception?: string;
    startCreatedAt?: Date;
    endCreatedAt?: Date;
    created_at?: Date;
    plate?: string;
    policy?: string;
}

export interface PqrCallInfo {
    id?: string;
    callId: string;
}

export interface PqrData {
    id?: string;
    branch?: string | ISelect;
    receptionChannel: string | ISelect;
    type?: string | ISelect;
    half?: string | ISelect;
    subtypeDp?: string | ISelect;
    procedure?: string | ISelect;
}

export interface PqrDataSfc {
    id?: string;
    sfcId?: string;
    channelPresentsFailure?: string | ISelect;
    controlEntity?: string | ISelect;
    receptionInstance: string | ISelect;
    receptionPoint?: string | ISelect;
    desistd?: string | ISelect;
    hasExpressComplaint?: boolean;
    dcfScaling?: boolean;
    isExtension?: boolean;
    isVirtualProduct?: boolean;
    isGuardianship?: boolean;
    guardianship?: string;
    marking?: string | ISelect;
    updateStatusPQRDate?: Date;
    answerSFCDate?: Date;
    admission?: string | ISelect;
    acceptance?: string | ISelect;
    rectification?: string | ISelect;
    closingDateDCF?: Date;
    customerFilingDate?: Date;
    detailProduct?: string;
    finalResponseAttached?: boolean;
    fraudType?: string | ISelect;
    fraudMode?: string | ISelect;
    claimedAmount?: string;
    approvedAmount?: string;
}

export interface PqrInitialCausality {
    id?: string;
    product: string | ISelect;
    motive: string | ISelect;
    submotive1?: string | ISelect;
    submotive2?: string | ISelect;
    submotive3?: string | ISelect;
    submotive4?: string | ISelect;
}

export interface PqrNotificationClient {
    id?: string;
    email: string;
    phone?: string;
}

export interface PqrInfo {
    id?: string;
    status: string | ISelect;
    country: string | ISelect;
    location: string | ISelect;
    correspondenceFiling?: string;
    detail: string;
}

export interface PqrInfoWeb {
    id?: string;
    country: string | ISelect;
    location: string | ISelect;
    channelPresentsFailure: string | ISelect;
    detail: string;
    type?: string | ISelect;
    acceptTerms?: boolean;
}

export interface PqrReconsideration {
    id?: string;
    hasReconsideration: boolean;
    replica?: string | ISelect;
    pqrReplica: string;
    observations: string;
}

export interface PqrProductData {
    id?: string;
    policy: string;
    bonusValue: string;
    plate?: string;
}

export interface PqrStrategicAlly {
    id?: string;
    strategicAlly: string | ISelect;
}

export interface PqrStatusManagement {
    id?: string;
    customerFilingDate?: Date;
    notificationProcedureDate?: Date;
    processingDate?: Date;
    suspensionDate?: Date;
    sendEmailExpansionInformation?: boolean;
    reactivationDate?: Date;
    extensionDate?: Date;
    sendEmailExtension?: boolean;
    alertSFCDate?: Date;
    responseDate?: Date;
    sendEmailResponse?: boolean;
    notificationResponseDate?: Date;
    sacDate?: Date;
    furagDate?: Date;
    closingDate?: Date;
    observation: string;
    editFuragAndSac?: boolean;
}

export interface PqrStatusManagement2 extends PqrStatusManagement {
    status?: string | ISelect;
}

export interface PqrRedirect {
    id?: string;
    area1: string | ISelect;
    person1: string | ISelect;
    email1: string;
    area2: string | ISelect;
    person2: string | ISelect;
    email2: string;
    area3: string | ISelect;
    person3: string | ISelect;
    email3: string;
    redirectPqr?: boolean;
    generateAlert?: boolean;
    addAnnex?: boolean;
    attachments?: Attachment[];
}

export interface PqrInFavorOf {
    id?: string;
    inFavorOf?: string | ISelect;
}

export interface PqrFinalCausality {
    id?: string;
    causality?: string | ISelect;
    motive?: string | ISelect;
    protection?: string | ISelect;
}

export interface PqrResponseMedium {
    id?: string;
    responseMedium?: string | ISelect;
    observation?: string;
}

export interface PqrClosing {
    id?: string;
    observation?: string;
    complianceTerms?: string | ISelect;
    nonComplianceReason?: string | ISelect;
    compensation?: boolean;
    auditObservations?: string;
    audit?: boolean;
    emailNotification?: boolean;
    typeCompensation: string | ISelect;
}

export interface PqrSurvey {
    id?: string;
    type?: 'V1' | 'V2';
    question1?: string;
    question2?: string;
    question3?: string;
    question4?: string;
    question5?: string;
    question6?: string;
    question7?: string;
    question8?: string;
    question9?: string;
    question10?: string;
    question11?: string;
    pqrId?: string;
    created_at?: Date;
}

export interface Pqr {
    id?: string;
    year?: number;
    consecutive?: number;
    consecutiveFormat?: string;
    reception?: string;
    alert?: string | ISelect;
    account?: Account;
    callInfo?: PqrCallInfo;
    data?: PqrData;
    dataSfc?: PqrDataSfc;
    initialCausality?: PqrInitialCausality;
    notificationClients?: PqrNotificationClient;
    info?: PqrInfo;
    attachments?: Attachment[];
    attachmentsFinally?: Attachment[];
    statusManagement?: PqrStatusManagement;
    reconsideration?: PqrReconsideration;
    productData?: PqrProductData;
    strategicAlly?: PqrStrategicAlly;
    redirect?: PqrRedirect;
    inFavorOf?: PqrInFavorOf;
    finalCausality?: PqrFinalCausality;
    responseMedium?: PqrResponseMedium;
    closing?: PqrClosing;
    survey?: PqrSurvey;
    responseSmart?: any;
    created_at?: Date;
    updated_at?: Date;
    createdBy?: IRegisterUser;
    updatedBy?: IRegisterUser;
    colorFuragDate?: string;
    colorSacDate?: string;
}

export interface PqrSmartHistory {
    created_at: Date;
    result: any;
    createdBy?: IRegisterUser;
}

export interface PqrFilterWeb {
    consecutiveFormat?: string;
    document?: string;
    typeDocument?: string;
}

export interface PqrResultWeb {
    id?: string;
    consecutiveFormat: string;
    info?: {
        status: {
            code: string;
            name: string;
        };
    };
    account?: {
        name: string;
        document: string;
    };
    statusManagement?: {
        closingDate: Date;
        extensionDate: Date;
        furagDate: Date;
        sacDate: Date;
        processingDate: Date;
        reactivationDate: Date;
        responseDate: Date;
        suspensionDate: Date;
    };
    survey?: PqrSurvey;
    redirect?: PqrRedirect;
    responseMedium?: PqrResponseMedium;
}

export interface PqrStatusHistory {
    created_at: Date;
    changes: Pqr;
    previousState?: Pqr;
    pqrId: Pqr;
    createdBy?: IRegisterUser;
}

export interface PqrAttachment {
    attachments: Attachment[];
    observation: string;
}
